import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

interface IApplicationContextState {
  logged: boolean;
  setLogged(): void;
  logout(): void;
}

interface ApplicationProviderProps {
  children: React.ReactNode;
}

const ApplicationContext = createContext<IApplicationContextState>(
  {} as IApplicationContextState,
);

export const ApplicationProvider: React.FC<ApplicationProviderProps> = ({
  children,
}) => {
  const [appLogged, setAppLogged] = useState(() => {
    const user = localStorage.getItem('@DCSAdmin:user');

    return user !== null;
  });

  const setLogged = useCallback(() => {
    setAppLogged(true);
  }, []);

  const logout = useCallback(() => {
    setAppLogged(false);
  }, []);

  const applicationContextValue = useMemo(
    () => ({
      logged: appLogged,
      setLogged,
      logout,
    }),
    [appLogged, setLogged, logout],
  );

  return (
    <ApplicationContext.Provider value={applicationContextValue}>
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplication = (): IApplicationContextState => {
  const context = useContext(ApplicationContext);

  if (!context) {
    throw new Error(
      'useApplication must be used within an ApplicationProvider',
    );
  }

  return context;
};
